module.exports = __webpack_public_path__ + "5bcbaf9989725250d82c0531e0920d7c.woff";